type NativeAPI = {
  launchLogin: () => void;
};

function getNativeAPI(): NativeAPI | null {
  if (typeof window === 'undefined') return null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const api = (window as any)?.ZMOB_nativeAPI as NativeAPI | undefined;
  return api?.launchLogin ? api : null;
}

export function isNativeWebView(): boolean {
  if (typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).has('fromApp');
}

export function launchNativeLogin(): boolean {
  const api = getNativeAPI();
  if (!api) return false;
  api.launchLogin();
  return true;
}
